@if (cardDetails) {
  <app-block-confirmation
    [cardDetail]="cardDetails"
    title="Block subscription card">
    <div specifyCard>
      <div class="h4 mt-5">"{{ cardDetails.name }}" subscription card has been blocked.</div>
    </div>
  </app-block-confirmation>
}
